import PropTypes from 'prop-types';
import React, { useState, useContext, useMemo, useCallback } from 'react';
import { InventoryContext } from './inventory-create-context';

export const useInventory = () => useContext(InventoryContext);

export const InventoryProvider = ({ children }) => {
    const [productSKUS, setProductSKUS] = useState([]);
    const [inventories, setInventories] = useState([]);
    const [quantity, setQuantity] = useState('')
    const [workOrderObject, setWorkOrderObject] = useState({});

    const updateWorkOrderObject = useCallback((object) => {
        setWorkOrderObject(object);
    }, []);

    const updateQuantity = useCallback((newQuantity) => {
        setQuantity(newQuantity);
    }, []);

    const updateProductSKUS = useCallback((newSKUS) => {
        setProductSKUS(newSKUS);
    }, []);

    const updateInventories = useCallback((newInventories) => {
        setInventories(newInventories);
    }, []);

    const contextValue = useMemo(() => ({
        inventories,
        productSKUS,
        quantity,
        workOrderObject,
        updateProductSKUS,
        updateInventories,
        updateQuantity,
        updateWorkOrderObject,
    }), [inventories, productSKUS, quantity, workOrderObject, updateInventories, updateProductSKUS, updateQuantity, updateWorkOrderObject]);

    return (
        <InventoryContext.Provider value={contextValue}>
            {children}
        </InventoryContext.Provider>
    );
};

InventoryProvider.propTypes = {
    children: PropTypes.node,
};
